import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaveEnoughToLiveOnTop = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 264,
	height: 181,
	viewBox: "0 0 264 181",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .25,
			d: "M96.1919 8.30825L92.1489 9.40914C71.0544 15.153 58.5008 36.7923 63.9857 57.9556C66.4795 67.578 72.4726 75.9244 80.7934 81.3628L94.9975 90.6466C104.561 96.8975 107.823 109.384 102.538 119.514L102.223 120.118C94.6517 134.631 105.181 152 121.55 152C123.31 152 125.064 151.787 126.773 151.365L191.945 135.283C199.805 133.343 206.43 128.074 210.089 120.851C212.062 116.956 213.09 112.652 213.09 108.286L213.09 107.187C213.09 90.1795 199.845 76.058 182.881 74.8515C167.136 73.7317 154.364 61.4902 152.68 45.7958L152.625 45.2829C152.046 39.8917 150.157 34.7241 147.122 30.2308L144.404 26.2058C133.82 10.536 114.437 3.34032 96.1919 8.30825Z",
			fill: "#2C64EF",
			className: "brand300"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_6368_18457)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 85.4194,
					y: 42.5078,
					width: 108.341,
					height: 83.4939,
					rx: 7.16302,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 85.5314,
					y: 42.6197,
					width: 108.117,
					height: 83.2701,
					rx: 7.0511,
					stroke: "black",
					strokeOpacity: .12,
					strokeWidth: .223844
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 85.4194,
					y: 42.5078,
					width: 108.341,
					height: 83.4939,
					rx: 7.16302,
					fill: "white",
					fillOpacity: .85
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 85.5314,
					y: 42.6197,
					width: 108.117,
					height: 83.2701,
					rx: 7.0511,
					stroke: "black",
					strokeOpacity: .12,
					strokeWidth: .223844
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M85.4194 49.6708C85.4194 45.7148 88.6264 42.5078 92.5825 42.5078H186.597C190.553 42.5078 193.76 45.7148 193.76 49.6708V60.4154H85.4194V49.6708Z",
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M85.4194 49.6708C85.4194 45.7148 88.6264 42.5078 92.5825 42.5078H186.597C190.553 42.5078 193.76 45.7148 193.76 49.6708V60.4154H85.4194V49.6708Z",
					fill: "white",
					fillOpacity: .5
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_6368_18457)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 79.4194,
					y: 36.5078,
					width: 108.341,
					height: 83.4939,
					rx: 7.16302,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 79.5314,
					y: 36.6197,
					width: 108.117,
					height: 83.2701,
					rx: 7.0511,
					stroke: "black",
					strokeOpacity: .12,
					strokeWidth: .223844
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 79.4194,
					y: 36.5078,
					width: 108.341,
					height: 83.4939,
					rx: 7.16302,
					fill: "white",
					fillOpacity: .93
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 79.5314,
					y: 36.6197,
					width: 108.117,
					height: 83.2701,
					rx: 7.0511,
					stroke: "black",
					strokeOpacity: .12,
					strokeWidth: .223844
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M79.4194 43.6708C79.4194 39.7148 82.6264 36.5078 86.5825 36.5078H180.597C184.553 36.5078 187.76 39.7148 187.76 43.6708V54.4154H79.4194V43.6708Z",
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M79.4194 43.6708C79.4194 39.7148 82.6264 36.5078 86.5825 36.5078H180.597C184.553 36.5078 187.76 39.7148 187.76 43.6708V54.4154H79.4194V43.6708Z",
					fill: "white",
					fillOpacity: .25
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6368_18457)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M70.4253 109.37L73.6164 117.493M73.3867 110.942C73.0198 110.007 71.8128 109.606 70.6912 110.047C69.5695 110.488 68.9583 111.603 69.3253 112.537C69.6922 113.471 70.8992 113.872 72.0208 113.432C73.1425 112.991 74.3494 113.392 74.7164 114.326C75.0833 115.26 74.4721 116.376 73.3504 116.816C72.2288 117.257 71.0219 116.856 70.6549 115.922",
				stroke: "#FFB70D",
				strokeLinecap: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M66.3327 108.896C67.1274 107.897 68.1723 107.126 69.3614 106.661C73.1 105.192 77.3211 107.032 78.7898 110.771C80.2585 114.51 78.4185 118.731 74.6799 120.199C70.9413 121.668 66.7202 119.828 65.2515 116.089C64.7673 114.857 64.6425 113.57 64.8276 112.349",
				stroke: "#FFB70D",
				strokeLinecap: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_d_6368_18457)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 73.4194,
					y: 30.5078,
					width: 108.341,
					height: 83.4939,
					rx: 7.16302,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 73.4194,
					y: 30.5078,
					width: 108.341,
					height: 83.4939,
					rx: 7.16302,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 73.5314,
					y: 30.6197,
					width: 108.117,
					height: 83.2701,
					rx: 7.0511,
					stroke: "black",
					strokeOpacity: .12,
					strokeWidth: .223844
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 108.888,
					y: 54.5078,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 122.771,
					y: 54.5078,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 136.646,
					y: 54.5078,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 150.529,
					y: 54.5078,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 164.404,
					y: 54.5078,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 81.1382,
					y: 68.3867,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 95.0132,
					y: 68.3867,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 108.888,
					y: 68.3867,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 122.771,
					y: 68.3867,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 136.646,
					y: 68.3867,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 150.529,
					y: 68.3867,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 164.404,
					y: 68.3867,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 81.1382,
					y: 82.2656,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 81.1382,
					y: 96.1406,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 95.0132,
					y: 82.2656,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 95.0132,
					y: 96.1406,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 108.888,
					y: 82.2656,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 108.888,
					y: 96.1406,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 122.771,
					y: 82.2656,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 122.771,
					y: 96.1406,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 136.646,
					y: 82.2656,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 136.646,
					y: 96.1406,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 150.529,
					y: 82.2656,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 164.404,
					y: 82.2656,
					width: 10.5207,
					height: 10.5207,
					rx: .447689,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M73.4194 37.6708C73.4194 33.7148 76.6264 30.5078 80.5825 30.5078H174.597C178.553 30.5078 181.76 33.7148 181.76 37.6708V48.4154H73.4194V37.6708Z",
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 89.54,
					cy: 39.9682,
					r: 3.58151,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 140.126,
					cy: 39.9682,
					r: 3.58151,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 114.837,
					cy: 39.9682,
					r: 3.58151,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 165.423,
					cy: 39.9682,
					r: 3.58151,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 89.54,
					cy: 39.9682,
					r: 3.58151,
					fill: "black",
					fillOpacity: .5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 140.126,
					cy: 39.9682,
					r: 3.58151,
					fill: "black",
					fillOpacity: .5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 114.837,
					cy: 39.9682,
					r: 3.58151,
					fill: "black",
					fillOpacity: .5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 165.423,
					cy: 39.9682,
					r: 3.58151,
					fill: "black",
					fillOpacity: .5
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 87.9663,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "#C7E9FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 138.552,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "#C7E9FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 113.263,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "#C7E9FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 163.849,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "#C7E9FF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 87.9663,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 138.552,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 113.263,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 163.849,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "#2C64EF",
					className: "brand300"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 87.9663,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "white",
					fillOpacity: .95
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 88.0782,
					y: 22.6197,
					width: 2.90998,
					height: 18.5791,
					rx: 1.45499,
					stroke: "black",
					strokeOpacity: .12,
					strokeWidth: .223844
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 138.552,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "white",
					fillOpacity: .95
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 138.664,
					y: 22.6197,
					width: 2.90998,
					height: 18.5791,
					rx: 1.45499,
					stroke: "black",
					strokeOpacity: .12,
					strokeWidth: .223844
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 113.263,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "white",
					fillOpacity: .95
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 113.375,
					y: 22.6197,
					width: 2.90998,
					height: 18.5791,
					rx: 1.45499,
					stroke: "black",
					strokeOpacity: .12,
					strokeWidth: .223844
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 163.849,
					y: 22.5078,
					width: 3.13382,
					height: 18.8029,
					rx: 1.56691,
					fill: "white",
					fillOpacity: .95
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 163.961,
					y: 22.6197,
					width: 2.90998,
					height: 18.5791,
					rx: 1.45499,
					stroke: "black",
					strokeOpacity: .12,
					strokeWidth: .223844
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_6368_18457)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M178.332 11.8863L175.709 20.21M179.648 14.9699C179.95 14.0127 179.263 12.9422 178.114 12.58C176.964 12.2177 175.788 12.701 175.486 13.6582C175.185 14.6154 175.871 15.6859 177.021 16.0482C178.17 16.4104 178.857 17.4809 178.555 18.4381C178.253 19.3953 177.077 19.8786 175.927 19.5163C174.778 19.1541 174.091 18.0836 174.393 17.1264",
				stroke: "#FFB70D",
				strokeLinecap: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M175.446 8.94701C176.692 8.6693 177.99 8.72625 179.207 9.11206C183.038 10.3195 185.164 14.4037 183.957 18.2347C182.749 22.0656 178.665 24.1922 174.834 22.9847C171.003 21.7773 168.877 17.6931 170.084 13.8621C170.482 12.599 171.194 11.5201 172.105 10.6865",
				stroke: "#FFB70D",
				strokeLinecap: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip2_6368_18457)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 67.3774,
					cy: 93.7833,
					r: 10,
					transform: "rotate(17.8868 67.3774 93.7833)",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M67.9392 89.6013C66.9698 89.5575 66.2123 90.0685 66.004 90.7137C65.7958 91.359 66.1117 92.2164 66.9241 92.7466L67.9392 89.6013ZM67.8307 94.8213L66.8159 97.9656C67.785 98.0104 68.5426 97.4994 68.7508 96.8542C68.9591 96.2089 68.6432 95.3515 67.8307 94.8213Z",
					fill: "#FFB70D"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M76.8941 96.8547C75.1977 102.111 69.5621 104.996 64.306 103.3C59.05 101.604 56.1644 95.968 57.8608 90.712C59.5571 85.4559 65.1927 82.5704 70.4488 84.2667C75.7048 85.963 78.5904 91.5987 76.8941 96.8547ZM69.4506 87.3596C69.6399 87.4207 69.7972 87.5545 69.8878 87.7315C69.9785 87.9086 69.9951 88.1144 69.934 88.3037L69.8366 88.6054C71.2981 89.3839 72.2257 90.9705 71.714 92.5559C71.6529 92.7452 71.5191 92.9025 71.3421 92.9932C71.165 93.0838 70.9592 93.1004 70.7699 93.0393C70.5806 92.9782 70.4233 92.8445 70.3327 92.6674C70.242 92.4904 70.2254 92.2845 70.2865 92.0952C70.4947 91.45 70.1788 90.5925 69.3667 90.0614L68.3009 93.3637C69.7625 94.1422 70.69 95.7288 70.1783 97.3143C69.6666 98.8997 67.9866 99.6448 66.3457 99.422L66.2483 99.7237C66.1872 99.913 66.0534 100.07 65.8764 100.161C65.6993 100.252 65.4935 100.268 65.3042 100.207C65.1149 100.146 64.9576 100.012 64.867 99.8351C64.7763 99.6581 64.7597 99.4523 64.8208 99.263L64.9182 98.9613C63.4567 98.1828 62.5291 96.5962 63.0408 95.0107C63.1019 94.8214 63.2357 94.6642 63.4127 94.5735C63.5898 94.4829 63.7956 94.4662 63.9849 94.5273C64.1742 94.5884 64.3315 94.7222 64.4221 94.8993C64.5128 95.0763 64.5294 95.2821 64.4683 95.4714C64.2601 96.1167 64.576 96.9741 65.3884 97.5043L66.4539 94.203C64.9923 93.4245 64.0648 91.8379 64.5765 90.2524C65.0882 88.6669 66.7682 87.9219 68.4091 88.1447L68.5065 87.843C68.5676 87.6537 68.7014 87.4964 68.8784 87.4058C69.0555 87.3151 69.2613 87.2985 69.4506 87.3596Z",
					fill: "#FFB70D"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip3_6368_18457)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 181.591,
					cy: 35.997,
					r: 10,
					transform: "rotate(-31.9704 181.591 35.997)",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M178.756 32.8698C178.097 33.5826 178 34.4912 178.359 35.0663C178.718 35.6415 179.577 35.9528 180.506 35.6735L178.756 32.8698ZM182.676 36.3181L184.426 39.1209C185.085 38.409 185.182 37.5004 184.823 36.9253C184.464 36.3501 183.605 36.0388 182.676 36.3181Z",
					fill: "#FFB70D"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M190.074 30.7022C192.998 35.3875 191.571 41.5559 186.885 44.4802C182.2 47.4045 176.032 45.9771 173.107 41.2918C170.183 36.6065 171.61 30.4381 176.296 27.5138C180.981 24.5895 187.149 26.0169 190.074 30.7022ZM178.017 30.2708C178.185 30.1655 178.389 30.1315 178.583 30.1764C178.777 30.2212 178.945 30.3412 179.05 30.51L179.218 30.7789C180.755 30.1635 182.566 30.4773 183.448 31.8906C183.553 32.0594 183.587 32.2631 183.542 32.4568C183.498 32.6506 183.378 32.8187 183.209 32.924C183.04 33.0293 182.836 33.0633 182.643 33.0184C182.449 32.9736 182.281 32.8536 182.176 32.6849C181.817 32.1097 180.957 31.7984 180.028 32.0768L181.865 35.0205C183.403 34.4051 185.213 34.7189 186.095 36.1322C186.978 37.5456 186.464 39.3101 185.236 40.4209L185.404 40.6898C185.509 40.8586 185.543 41.0622 185.498 41.256C185.453 41.4498 185.333 41.6178 185.165 41.7232C184.996 41.8285 184.792 41.8625 184.598 41.8176C184.405 41.7728 184.236 41.6528 184.131 41.484L183.963 41.2151C182.426 41.8305 180.615 41.5167 179.733 40.1034C179.628 39.9346 179.594 39.7309 179.639 39.5372C179.683 39.3434 179.803 39.1753 179.972 39.07C180.141 38.9647 180.345 38.9307 180.538 38.9756C180.732 39.0204 180.9 39.1404 181.006 39.3091C181.364 39.8843 182.224 40.1956 183.153 39.9163L181.316 36.9735C179.779 37.5889 177.968 37.2751 177.086 35.8617C176.204 34.4484 176.717 32.6839 177.945 31.5731L177.777 31.3042C177.672 31.1354 177.638 30.9318 177.683 30.738C177.728 30.5442 177.848 30.3761 178.017 30.2708Z",
					fill: "#FFB70D"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_6368_18457",
				x: 77.4194,
				y: 36.5078,
				width: 124.341,
				height: 99.4941,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_6368_18457"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_6368_18457",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_6368_18457",
				x: 71.4194,
				y: 30.5078,
				width: 124.341,
				height: 99.4941,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_6368_18457"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_6368_18457",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_6368_18457",
				x: 65.4194,
				y: 16.5078,
				width: 124.341,
				height: 107.494,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_6368_18457"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_6368_18457",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_6368_18457",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 16,
					height: 16,
					fill: "white",
					transform: "translate(61.6494 108.91) rotate(-21.4474)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_6368_18457",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 16,
					height: 16,
					fill: "white",
					transform: "translate(171.795 6.01172) rotate(17.4944)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip2_6368_18457",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 20,
					height: 20,
					fill: "white",
					transform: "translate(60.9321 81.1953) rotate(17.8868)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip3_6368_18457",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 20,
					height: 20,
					fill: "white",
					transform: "translate(167.812 32.8086) rotate(-31.9704)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgSaveEnoughToLiveOnTop);
export { ForwardRef as ReactComponent };
